import secondaryComponents from "../../..";
import { useProducts } from "./useProductTable";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { PurchaseOrderImage } from "../../../../../assets/svgImages";
import { useSelector } from "react-redux";
import primaryComponents from "../../../../primaryComponents";

export const ProductTable = ({
  pOForm,
  setPOForm = () => {},
  ...validationParams
}) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { instance, addProductToPO } = useProducts({
    pOForm,
    setPOForm,
    ...validationParams,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  const {
    register,
    control,
    formState: { errors },
  } = validationParams;

  return (
    <div className={`${globalStyles.tableWrapper} ${styles.pOFormTable}`}>
      <div className={`${globalStyles.tableHeader}`}>
        <div className="d-flex w-100 align-items-end" style={{ gap: "10px" }}>
          <div className="w-100" style={{ maxWidth: "200px" }}>
            <primaryComponents.SelectFieldV2
              control={control}
              name={"store_id"}
              register={register}
              label="Store"
              value={
                storeList?.find(
                  (store) => `${store?.id}` === `${pOForm?.store_id}`,
                )?.name || "Select store"
              }
              options={storeList}
              idKey="id"
              nameKey="name"
              isRequired
              errorMessage={errors?.store_id}
              onChange={(value) => {
                setPOForm((prevState) => ({
                  ...prevState,
                  store_id: value,
                }));
              }}
              floatError={false}
            />
          </div>
          <secondaryComponents.BulkRestockComboBox
            store_id={pOForm?.store_id}
            exclude_on_demand_composite_products={true}
            handleAppendRestockData={addProductToPO}
          />
        </div>
      </div>

      {/* table section */}
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        classNames={`${styles.tableSection}`}
      >
        <div className="py-5 text-center">
          <PurchaseOrderImage />
          <h4>Items you select will appear here</h4>
        </div>
      </secondaryComponents.TableHelper>
    </div>
  );
};
